<template>
    <section class="stats-main">
        <div class="stats-wrapper">
            <div class="s-top-shape1"></div>
            <div class="s-top-shape2"></div>
            <div class="s-bot-shape1"></div>
            <div class="s-bot-shape2"></div>
            <ul>
                <li>
                    <div class="card-main">
                        <img src="../../../public/img/rating.png" alt="">
                        <span>{{$t("Home.Stats.span1")}}</span>
                    </div>
                </li>
                <li>
                    <div class="card-main">
                        <img src="../../../public/img/cruise.png" alt="">
                        <span>{{$t("Home.Stats.span2")}}</span>
                    </div>
                </li>
                <li>
                    <div class="card-main">
                        <img src="../../../public/img/scaffolding.png" alt="">
                        <span>{{$t("Home.Stats.span3")}}</span>
                    </div>
                </li>
                <li>
                    <div class="card-main">
                        <img src="../../../public/img/paint-roller.png" alt="">
                        <span v-html="$t('Home.Stats.span4')"></span>
                    </div>  
                </li>
            </ul>
        </div>
        <router-link class="router-link" :to="`/${$i18n.locale}/about`">
            <v-btn color="white" width="200" large outlined>{{$t('Home.Stats.btn')}}</v-btn>
        </router-link>
    </section>
</template>

<script>
export default {
    name: 'home-stats'
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
$shape-color: #14525e;
.stats-main {
    display: flex;
    flex-direction: column;
    height: auto;
    background-color: #10424b;
    padding: 0 0 40px 0;
    .stats-wrapper {
        width: 100%;
        min-height: 350px;
        display: flex;
        justify-content: center;
        .s-top-shape1 {
            margin: 83px 0 0 60%;
            position: absolute;
            width: 120px;
            height: 175px;
            background-color: $shape-color;
            transform: skew(20deg);
            @include mobile {
                width: 80px;
            }
        }
    
        .s-bot-shape1 {
            margin: 258px 0 0 60%;
            position: absolute;
            width: 120px;
            height: 175px;
            background-color: $shape-color;
            transform: skew(-20deg);
            @include mobile {
                width: 80px;
            }
        }
    
        .s-top-shape2 {
            margin: 0 0 0 -80%;
            position: absolute;
            width: 120px;
            height: 175px;
            background-color: $shape-color;
            transform: skew(20deg);
            @include mobile {
                width: 80px;
            }
        }
    
        .s-bot-shape2 {
            margin: 175px 0 0 0 - 80%;
            position: absolute;
            width: 120px;
            height: 175px;
            background-color: $shape-color;
            transform: skew(-20deg);
            @include mobile {
                width: 80px;
            }
        }
        ul {
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin: 0;
            padding: 0;
            z-index: 2;
            margin: 50px 0 20px 0;
            li {
                list-style-type: none;
                border: 0.5px solid gray;
                .card-main {
                    background-color: white;
                    height: 250px;
                    width: 320px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    padding: 20px;
                    img {
                        max-width: 120px;
                        margin: 0 0 20px 0;
                        @include mobile {
                            max-width: 100px;
                        }
                    }
                    span {
                        font-size: 24px;
                        padding: 0 15px 0 15px;
                        @include mobile {
                            font-size: 20px;
                        }
                    }
                }
            }
        }
    }
}
</style>